import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var isArray = _Array$isArray || function (x) {
  return x && typeof x.length === 'number';
};